import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { types as sdkTypes } from '../../util/sdkLoader';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';
import { pastShiftTransitions } from '../../util/transaction';

export const FETCH_WORKERS_DATA_REQUEST = 'app/WorkerDetailsPage/FETCH_WORKERS_DATA_REQUEST';
export const FETCH_WORKERS_DATA_SUCCESS = 'app/WorkerDetailsPage/FETCH_WORKERS_DATA_SUCCESS';
export const FETCH_WORKERS_DATA_ERROR = 'app/WorkerDetailsPage/FETCH_WORKERS_DATA_ERROR';

export const FETCH_LISTING_OF_TRANSACTION_REQUEST =
  'app/WorkerDetailsPage/FETCH_LISTING_OF_TRANSACTION_REQUEST';
export const FETCH_LISTING_OF_TRANSACTION_SUCCESS =
  'app/WorkerDetailsPage/FETCH_LISTING_OF_TRANSACTION_SUCCESS';
export const FETCH_LISTING_OF_TRANSACTION_ERROR =
  'app/WorkerDetailsPage/FETCH_LISTING_OF_TRANSACTION_ERROR';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

// ================ Reducer ================ //
const initialState = {
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  currentStaffData: [],
  fetchListing: false,
  fetchListingError: null,
  listingOfTransaction: [],
};

export default function WorkerGigDetailsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_WORKERS_DATA_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        fetchWorkersDataError: null,
        currentStaffData: [],
      };
    case FETCH_WORKERS_DATA_SUCCESS: {
      return {
        ...state,
        fetchInProgress: false,
        currentStaffData: payload,

        // pagination: payload.data.meta,
      };
    }
    case FETCH_WORKERS_DATA_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchWorkersDataError: payload };

    case FETCH_LISTING_OF_TRANSACTION_REQUEST:
      return {
        ...state,
        fetchListing: true,
        fetchListingError: null,
        listingOfTransaction: [],
      };
    case FETCH_LISTING_OF_TRANSACTION_SUCCESS:
      const transactions = sortedTransactions(payload.data.data);
      console.log(888, transactions);
      return {
        ...state,
        fetchListing: false,
        listingOfTransaction: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    case FETCH_LISTING_OF_TRANSACTION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchListing: false, fetchListingError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
const fetchWorkersDataRequest = () => ({ type: FETCH_WORKERS_DATA_REQUEST });
const fetchWorkersDataSuccess = response => ({
  type: FETCH_WORKERS_DATA_SUCCESS,
  payload: response,
});
const fetchWorkersDataError = e => ({
  type: FETCH_WORKERS_DATA_ERROR,
  error: true,
  payload: e,
});
const fetchlistingOfTransactionRequest = () => ({ type: FETCH_LISTING_OF_TRANSACTION_REQUEST });
const fetchlistingOfTransactionSuccess = response => {
  return {
    type: FETCH_LISTING_OF_TRANSACTION_SUCCESS,
    payload: response,
  };
};
const fetchlistingOfTransactionError = e => ({
  type: FETCH_LISTING_OF_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //
const fetchWorkerData = param => async (dispatch, getState, sdk) => {
  const { workerId } = param;
  dispatch(fetchWorkersDataRequest());
  return sdk.users
    .show({
      id: workerId,
      include: ['profileImage'],
      'fields.image': ['variants.default', 'variants.square-small', 'variants.square-small2x'],
    })
    .then(res => {
      return dispatch(fetchWorkersDataSuccess(res?.data));
    })
    .catch(error => {
      dispatch(fetchWorkersDataError(error));
    });
};
const fetchWorkedGig = param => async (dispatch, getState, sdk) => {
  const { workerId } = param;
  dispatch(fetchlistingOfTransactionRequest());
  return sdk.transactions
    .query({
      only: 'sale',
      userId: workerId,
      lastTransitions: [pastShiftTransitions],
      include: [
        'provider',
        'provider.profileImage',
        'customer',
        'customer.profileImage',
        'booking',
        'listing',
      ],
      'fields.transaction': [
        'lastTransition',
        'lastTransitionedAt',
        'transitions',
        'payinTotal',
        'payoutTotal',
      ],

      'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(res => {
      // console.log(1234, res);
      dispatch(addMarketplaceEntities(res));
      dispatch(fetchlistingOfTransactionSuccess(res));
    })
    .catch(error => {
      dispatch(fetchlistingOfTransactionError(error));
    });
};

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const { workerId } = params;

  dispatch(fetchWorkerData(params)).then(() => {
    dispatch(fetchWorkedGig(params));
  });
};
